export default __webpack_public_path__ + "static/media/beyonce.1eccea04.gif";